import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import "./index.css";
import EnterDetailsVendorTxn from "../../../components/CreateTxn/CreateVendorTxn/EnterDetails";
import CreateVendorTxnForm from "../../../components/CreateVendorTxnForm";
import { useSelector, useDispatch } from "react-redux";
import { setBufferState } from "../../../redux/features/bufferState/bufferState";
import TransactionStatus from "./TransactionStatus";
import { createVendorAccount } from "../../../redux/features/createVendorAcc/createVendorAcc";
import SelectPayment from "./SelectPayment";
import { resetVerification } from "../../../redux/features/verifyPAN/verifyPAN";
import RegisterdFilledForm from "../../../components/CreateVendorTxnForm/RegisterdFilledForm";
import CustomizedStepper from "../../../components/CreateTxn/CustomizedStepper";
import SelectedVendorAccount from "../../../components/CreateVendorTxnForm/SelectedVendorAccount";
import { createVendorTxn } from "../../../redux/features/createTxn/createTxn";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { accountViewAllDetails } from "../../../redux/features/accounts/viewAll";

const CreateVendorTxn = () => {
  const services = useSelector((state) => state.refreshToken.services);
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const vendor_id = searchParams.get("vendor_id");

  const selectedAcc = useSelector((state) => state.bufferState.vendor);
  const createAcc = useSelector((state) => state.createAcc.vendor);
  const [showStatus, setShowStatus] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const createdVendorTxn = useSelector((state) => state.createTxn.vendor);
  const createdVendorTxnLoading = useSelector(
    (state) => state.createTxn.isLoading
  );
  const [checkRes, setCheckRes] = useState(false);
  const [nextButtonEnabled, enableNextButton] = useState(false);

  const [createTxnData, setCreateTxnData] = useState({
    amount: null,
    distribution_remark: null,
    invoice_no: null,
    vendor_id: null,
  });

  const [registerNewVnerdorData, setRegisterNewVnerdorData] = useState({
    vendor_id: "",
    pan_no: "",
    bank_acc_no: "",
    ifsc_code: "",
    contact_no: "",
    name: "",
    skip_account_verification: "",
    email_id: "",
    gstin: "",
  });

  const vendor = useSelector((state) => {
    if (!vendor_id) return null;
    if (!state.accountViewAll.records) {
      dispatch(
        accountViewAllDetails({
          account_type: "vendor",
          account_id: vendor_id,
        })
      );
    }
    return state.accountViewAll.records
      ? state.accountViewAll.records[0]
      : null;
  });

  useEffect(() => {
    if (!vendor_id) return;
    dispatch(
      accountViewAllDetails({
        account_type: "vendor",
        account_id: vendor_id,
      })
    );
  }, [vendor_id]);

  useEffect(() => {
    if (vendor) {
      dispatch(setBufferState({ vendor: vendor }));
    }
  }, [vendor]);

  useEffect(() => {
    if (checkRes && createAcc.errors) {
      toast.error(Object.values(createAcc.errors)[0][0], {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (checkRes && createAcc.status) setShowStatus(true);
    setCheckRes(true);
  }, [createAcc]);

  useEffect(() => {
    if (checkRes && createdVendorTxn.errors) {
      toast.error(Object.values(createdVendorTxn.errors)[0][0], {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (checkRes && createdVendorTxn.status) setShowStatus(true);
    setCheckRes(true);
  }, [createdVendorTxn]);

  useEffect(() => {
    if (activeStep === 0 && !createTxnData.amount && !vendor_id) {
      dispatch(setBufferState({ vendor: null }));
    }
    let newCreateTxnData = { ...createTxnData, ["vendor_id"]: null };
    if (selectedAcc) {
      newCreateTxnData = {
        ...newCreateTxnData,
        ["vendor_id"]: selectedAcc.vendor_id,
      };
    }
    if (createAcc && createAcc.status) {
      newCreateTxnData = {
        ...newCreateTxnData,
        ["vendor_id"]: createAcc.accounts
          ? createAcc.accounts[0].vendor_id
          : "",
      };
    }
    setCreateTxnData(newCreateTxnData);
  }, [selectedAcc, createAcc, registerNewVnerdorData]);

  const steps = [
    "Enter amount and additional details",
    "Enter vendor details",
    "Confirm and create transaction",
  ];

  const handleNext = () => {
    if (createTxnData?.amount <= 10) {
      toast.error("Transaction amount should be more than ₹10", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    if (activeStep === 2) {
      dispatch(createVendorTxn(createTxnData));
    }
    if (activeStep === 1) {
      if (!selectedAcc?.vendor_id) {
        dispatch(createVendorAccount(registerNewVnerdorData));
      }
    }
    if (activeStep === 0) {
      dispatch(resetVerification());
    }
    if (activeStep === 0 && createTxnData.amount) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      enableNextButton(false);
    }
    if (activeStep === 1 && createTxnData.vendor_id) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      enableNextButton(true);
    } else if (
      activeStep === 1 &&
      registerNewVnerdorData.bank_acc_no &&
      registerNewVnerdorData.ifsc_code &&
      registerNewVnerdorData.contact_no &&
      registerNewVnerdorData.name &&
      registerNewVnerdorData.email_id &&
      registerNewVnerdorData.pan_no
    )
      if (createAcc && createAcc.status === "true") {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
  };

  const handleBack = () => {
    if (activeStep === 1 && createTxnData.amount) {
      enableNextButton(true);
    }
    if (activeStep === 2 && selectedAcc?.bank_name && selectedAcc?.ifsc_code) {
      enableNextButton(true);
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box
      className="bg-custom-appBack
      flex flex-row justify-center overflow-y-auto overflow-x-hidden w-full hide-scrollbar vendor-txn
      min-h-screen"
    >
      {showStatus && !createdVendorTxnLoading ? (
        <div>
          {services.includes("Settle_txn") &&
            createdVendorTxn?.transactions[0].approval_status === "Y" ? (
            <SelectPayment
              createTxnData={createTxnData}
              selectedAcc={selectedAcc}
              registerNewVnerdorData={registerNewVnerdorData}
              account={
                selectedAcc && selectedAcc.bank_acc_no
                  ? selectedAcc.bank_acc_no
                  : registerNewVnerdorData.bank_acc_no
              }
              amount={createTxnData.amount}
              txn_initiator_name={
                selectedAcc && selectedAcc.created_by_name
                  ? selectedAcc.created_by_name
                  : registerNewVnerdorData.name
              }
              ifsc={
                selectedAcc && selectedAcc.ifsc_code
                  ? selectedAcc.ifsc_code
                  : registerNewVnerdorData.ifsc_code
              }
              distribution_remark={createTxnData.distribution_remark}
              invoice_no={createTxnData.invoice_no}
              vendor_id={createTxnData.vendor_id}
            />
          ) : (
            <Box sx={{ marginTop: "-120px" }}>
              <TransactionStatus
                txn_status={"created succesfully!"}
                approval_status={
                  createdVendorTxn?.transactions[0].approval_status
                }
                txn_id={createdVendorTxn?.transactions[0].txn_id}
                account={
                  selectedAcc && selectedAcc.bank_acc_no
                    ? selectedAcc.bank_acc_no
                    : registerNewVnerdorData.bank_acc_no
                }
                amount={createTxnData.amount}
                vendor_name={
                  selectedAcc && selectedAcc.name
                    ? selectedAcc.name
                    : registerNewVnerdorData.name
                }
                ifsc={
                  selectedAcc && selectedAcc.ifsc_code
                    ? selectedAcc.ifsc_code
                    : registerNewVnerdorData.ifsc_code
                }
                distribution_remark={createTxnData.distribution_remark}
                invoice_no={createTxnData.invoice_no}
                vendor_id={createTxnData.vendor_id}
              />
            </Box>
          )}
        </div>
      ) : (
        <div
          className="self-center
          h-screen w-full
          xl:w-10/12"
        >
          <div
            className="mt-24 h-fit
            flex flex-col gap-2 3xl:gap-4 5xl:gap-6
            py-6 3xl:py-8 4xl:py-14 5xl:py-16 6xl:py-20"
          >
            <div
              className="h-1/5
              flex flex-row justify-center"
            >
              <CustomizedStepper
                nextButtonEnabled={nextButtonEnabled}
                activeStep={activeStep}
                steps={steps}
                handleBack={handleBack}
                handleNext={handleNext}
              />
            </div>
            <div className="h-4/5 flex flex-row justify-center pb-24">
              <div className="w-10/12 h-full">
                {activeStep === 0 && (
                  <div className="p-4 3xl:p-6 4xl:p-8 5xl:p-10 6xl:p-12">
                    <div className="w-1/2 h-fit">
                      <EnterDetailsVendorTxn
                        setCreateTxnData={setCreateTxnData}
                        createTxnData={createTxnData}
                        enableNextButton={enableNextButton}
                      />
                    </div>
                  </div>
                )}
                {activeStep === 1 && (
                  <div className="flex flex-row justify-end p-4 3xl:p-6 4xl:p-8 5xl:p-10 6xl:p-12">
                    <div className="w-1/2 h-fit">
                      <CreateVendorTxnForm
                        setRegisterNewVnerdorData={setRegisterNewVnerdorData}
                        registerNewVnerdorData={registerNewVnerdorData}
                        enableNextButton={enableNextButton}
                        editable={true}
                      />
                    </div>
                  </div>
                )}
                {activeStep === 2 && (
                  <div
                    className="flex flex-row justify-between
                    p-4 3xl:p-6 4xl:p-8 5xl:p-10 6xl:p-12"
                  >
                    <div className="w-[49%] h-fit">
                      <EnterDetailsVendorTxn
                        disabledToggle={createTxnData.amount ? true : false}
                        setCreateTxnData={setCreateTxnData}
                        createTxnData={createTxnData}
                        enableNextButton={enableNextButton}
                        filled="true"
                      />
                    </div>
                    {selectedAcc?.vendor_id ? (
                      <div className="w-[49%] h-fit">
                        <SelectedVendorAccount
                          selectedAcc={selectedAcc}
                          editable={false}
                          enableNextButton={enableNextButton}
                        />
                      </div>
                    ) : (
                      <div className="w-[49%] h-fit">
                        <RegisterdFilledForm
                          registerNewVnerdorData={registerNewVnerdorData}
                          enableNextButton={enableNextButton}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </Box>
  );
};

export default CreateVendorTxn;
